import { QueryClient } from "@tanstack/react-query";
import { microspaceQueryKeys } from "src/pages/MicrospaceAnalysis/store/microspaceQueryKeys";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

queryClient.setQueryDefaults(microspaceQueryKeys.all, { refetchOnWindowFocus: false });
